import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import './index.css';
import './App.css';

// Import pages (we'll create these)
import Onboarding from './pages/Onboarding';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Category from './pages/Category';
import Lookbook from './pages/Lookbook';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OrderConfirmation from './pages/OrderConfirmation';
import Rewards from './pages/Rewards';
import Account from './pages/Account';
import OrderHistory from './pages/OrderHistory';
import Admin from './pages/Admin';
import AdminProductEdit from './pages/AdminProductEdit';
import AdminProductAdd from './pages/AdminProductAdd';
import Profile from './pages/Profile';
import TheLoopGame from './pages/TheLoopGame';

function App() {
  const [deviceId, setDeviceId] = useState('');
  // Onboarding is OFF by default — new visitors land straight on the shop.
  // The Onboarding component is kept in the repo in case you ever want to
  // bring it back for a marketing push (e.g. an email-capture campaign),
  // but it's bypassed here.
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [userName, setUserName] = useState('');
  const [userAvatar, setUserAvatar] = useState('');

  useEffect(() => {
    // Get or create device ID
    let id = localStorage.getItem('device_id');
    if (!id) {
      id = uuidv4();
      localStorage.setItem('device_id', id);
    }
    setDeviceId(id);

    // Hydrate any previously-stored name/avatar (from a prior session, before
    // onboarding was disabled) so the Account/Shop headers still display it.
    const storedName = sessionStorage.getItem('user_name') || '';
    const storedAvatar = sessionStorage.getItem('user_avatar') || '';
    if (storedName) setUserName(storedName);
    if (storedAvatar) setUserAvatar(storedAvatar);
  }, []);

  const handleOnboardingComplete = (name, avatar) => {
    setUserName(name);
    setUserAvatar(avatar);
    setShowOnboarding(false);
    sessionStorage.setItem('onboarding_complete', 'true');
    sessionStorage.setItem('user_name', name);
    sessionStorage.setItem('user_avatar', avatar);
  };

  if (showOnboarding) {
    return (
      <Router>
        <Onboarding onComplete={handleOnboardingComplete} />
      </Router>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Shop deviceId={deviceId} userName={userName} />} />
        <Route path="/product/:id" element={<ProductDetail deviceId={deviceId} />} />
        <Route path="/category/:category" element={<Category deviceId={deviceId} />} />
        <Route path="/lookbook" element={<Lookbook />} />
        <Route path="/cart" element={<Cart deviceId={deviceId} />} />
        <Route path="/checkout" element={<Checkout deviceId={deviceId} />} />
        <Route path="/order-confirmation" element={<OrderConfirmation deviceId={deviceId} />} />
        <Route path="/rewards" element={<Rewards deviceId={deviceId} />} />
        <Route path="/account" element={<Account deviceId={deviceId} userName={userName} userAvatar={userAvatar} />} />
        <Route path="/profile" element={<Profile deviceId={deviceId} />} />
        <Route path="/orders" element={<OrderHistory deviceId={deviceId} />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/products/add" element={<AdminProductAdd />} />
        <Route path="/admin/products/:id/edit" element={<AdminProductEdit />} />
        <Route path="/the-loop-game" element={<TheLoopGame />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
